// NOTE: hooks
import { toast } from 'sonner'
import useStaffInvitation from './useStaffInvitation'
// NOTE: components
import Modal from '../ui/Modal'
import ReactLoading from 'react-loading'
import Loading from '../ui/Loading'

const StaffInvitation = () => {
	const { invitation, isLoadingInvitation, isErrorInvitation, errorInvitation, isLoadingAccepting, isLoadingDecline, show, close, accept, decline } = useStaffInvitation()

	if (isLoadingInvitation) return <Loading />

	if (isErrorInvitation) {
		toast.error("Couldn't load your invitations", { description: errorInvitation?.message })
	} 

	return (
		<>
			{invitation && (
				<Modal size="sm" show={show} onHide={close}>
					<Modal.Header onHide={close}>{`Join the ${invitation?.name} team`}</Modal.Header>

					<Modal.Body>
						<p>{`${invitation?.name} invites you to join their team, providing additional support and becoming part of their community of wellbeing champions.`}</p>
					</Modal.Body>
					<Modal.Footer className="flex">
						<div className="ml-auto flex">
							<button
								className="text-dark mr-4 rounded-full bg-gradient-to-r from-slate-100 to-slate-200 px-8 py-2 font-semibold shadow-sm"
								disabled={isLoadingAccepting || isLoadingDecline}
								onClick={() => decline()}
							>
								{!isLoadingDecline && 'Decline'}

								{isLoadingDecline && (
									<div
										style={{ height: 26 }}
										className="m-0 flex w-full flex-wrap justify-center p-0"
									>
										<ReactLoading type={'spin'} color={'#334251'} width={'1.5rem'} delay={100} />
									</div>
								)}
							</button>

							<button
								className="rounded-full bg-gradient-to-r from-orange-600 to-orange-500 px-10 py-2 font-semibold text-white shadow"
								disabled={isLoadingAccepting || isLoadingDecline}
								onClick={() => accept()}
							>
								{!isLoadingAccepting && 'Accept'}

								{isLoadingAccepting && (
									<div
										style={{ height: 26 }}
										className="m-0 flex w-full flex-wrap justify-center p-0"
									>
										<ReactLoading type={'spin'} color={'#334251'} width={'1.5rem'} delay={100} />
									</div>
								)}
							</button>
						</div>
					</Modal.Footer>
				</Modal>
			)}
		</>
	)
}

export default StaffInvitation
